import { render } from "./VesselsContent.vue?vue&type=template&id=bcfe401e"
import script from "./VesselsContent.vue?vue&type=script&lang=js"
export * from "./VesselsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__